import { APGPrintRequest } from './model/apg-print-request';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Template } from './../masterdata/models/template';
import { Component, OnInit } from '@angular/core';
import { CarrierStatusService } from '../carrier-status/carrier-status.service';
import { SelectItem, Message } from 'primeng/api';
import { Printer } from '../masterdata/models/printer';
import { ErrorHandler } from '../utils/error-handler';
import { APGPrintService } from './apg-print-service';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector: 'app-apg-print-labels',
  templateUrl: './apg-print-labels.component.html',
  styleUrls: ['./apg-print-labels.component.css']
})
export class ApgPrintLabelsComponent implements OnInit {
  display = false;
  msgs: Message[] = [];
  quantity = 1;
  printers: SelectItem[] = [];
  templates: SelectItem[] = [];
  selectedPrinter: Printer;
  selectedTemplate: Template;
  localLab: any;
  errorHandler: ErrorHandler = new ErrorHandler;
  labelPrefix: string;
  labelFrom: string;
  labelTo: string;
  apgPrintRequest: APGPrintRequest;

  printForm = new FormGroup({
    'printer': new FormControl('',Validators.required),
    'template': new FormControl('', Validators.required),
    'prefix': new FormControl('', Validators.required),
    'from': new FormControl(''),
    'to': new FormControl(''),
    'count': new FormControl('')
  });

  constructor( private carrierStatusService: CarrierStatusService, private apgPrintService: APGPrintService, private _messagesService: MessagesService) {
  }

  ngOnInit() {

  }

  openDialog() {
    // Get local lab
    this.localLab = JSON.parse(localStorage.getItem('lab'));
    this.printers = [];
    this.templates = [];
    // Get list of printers from MDM
    this.initializePrinters();
    this.initalizeTemplates();
    this.selectedPrinter = null;
    this.selectedTemplate = null;
    this.labelPrefix = null;
    this.labelFrom = null;
    this.labelTo = null;
    this.display = true;
  }

  initializePrinters() {
    this.carrierStatusService.getPrintersList(this.localLab.lab, true).subscribe(
      result => {
        if (!result) {
          return;
        }
        // If printer list not empty
        result.data.forEach(printer => {
          this.printers.push({ label : printer.name, value: printer })
        })
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  initalizeTemplates() {
    this.apgPrintService.getActiveTemplatesForLab(this.localLab.lab._id, true).subscribe(
      result => {
        if (!result) {
          return;
        }
        result.data.forEach(template => {
          this.templates.push({ label : template.templateName, value: template })
        })
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  // Service call to print generate label print requests
  printLabelBarcodes() {
    this.apgPrintRequest = new APGPrintRequest();
    this.apgPrintRequest.printer = this.selectedPrinter;
    this.apgPrintRequest.template = this.selectedTemplate;
    this.apgPrintRequest.cutsomPrefix = this.labelPrefix;
    this.apgPrintRequest.customFrom = this.labelFrom;
    this.apgPrintRequest.customTo = this.labelTo;
    this.apgPrintRequest.numberOfCopies = this.quantity;
    this.apgPrintService.printLabel(this.apgPrintRequest).subscribe(
      result =>{
        if(!result || !result.data) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Print Failed', detail: 'Print failed due to unkown cause. Please contact support.'});
          return;
        }
        if(result.data) {
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Print Successful', detail: 'Print Successful!'});
          return
        }

      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }
}
